import Swiper from 'swiper';
import 'jquery.easing';

export function aboutFunc() {

  let aboutPage = $('#about').length;
  let brandMessage = $('#about.brandMessage').length;
  let subNav = document.getElementById('subNav');
  let subNavBtn = document.getElementById('subNavBtn');
  let subNavMenu = document.getElementById('subNavMenu');
    
  let aboutDistributorSubNavBtn = $('#aboutDistributorSubNavBtn');

  if (aboutPage) {
    if(!(brandMessage)){
      $(window).on('scroll', function () {
        let scrTop = $(window).scrollTop();
        if (scrTop > 20) {
          subNav.classList.add('notTop');
        } else {
          subNav.classList.remove('notTop');
        }
      });
    }
    

    //サブナビ
    if(!(brandMessage)){
      subNavBtn.addEventListener('click', function () {
        if (subNavMenu.classList.contains('isOpen')) {
          subNavBtn.classList.remove('isOpen');
          subNavMenu.classList.remove('isOpen');
        } else {
          subNavBtn.classList.add('isOpen');
          subNavMenu.classList.add('isOpen');
        }
      });
      $(window).on('scroll', function () {
        let scrTop = $(window).scrollTop();
        if (scrTop > 10) {
          subNavBtn.classList.remove('isOpen');
          subNavMenu.classList.remove('isOpen');
        }
      });
    }
     
    //地図サブナビ
    aboutDistributorSubNavBtn.on('click', function () {
        $(this).toggleClass('isOpen');
        $("html, body").animate({scrollTop: $('#aboutDistributorSubNav').offset().top - 140}, 1600, 'swing');
        return false;
    });
    
    //地図をクリックした際の処理
    var thisMap, continent, countryArea, changeJs, areaList, currentList, mapName, responsibleCheck, activeSp;
    thisMap = $('.globalMap').find('#global_map').find('g');
    countryArea = $('.aboutDistributorList');
    changeJs = $('.aboutDistributorSubNavMenu li');
            
    thisMap.hover(function () {
      continent = $(this).attr('id');
      $(this).find('path').addClass('cls-3'); 
      $(this).find('text').addClass('cls-4');
    }, function () {
      $(this).find('path').removeClass('cls-3'); 
      $(this).find('text').removeClass('cls-4');
    });
      
    thisMap.on('click', function () {
      areaList = $('section.' + continent);
      currentList = $('.aboutDistributorSubNavMenu li.' + continent);
      if ($(areaList).css('display') == 'none') {
        countryArea.not(areaList).css('display', 'none');
        areaList.css('display', 'block');
      };
        
      thisMap.removeClass('active');
      $(this).addClass('active'); 

      changeJs.removeClass('active');
      currentList.addClass('active');

      mapName = $(this).find('text').attr('id'); 
      $('.selectBtn').html(mapName);
      responsibleCheck = $('#responsibleCheck').width();
      activeSp = $('.activeSp');

      if (responsibleCheck == '2') {
        $('#changeJs').slideUp(500);
        activeSp.removeClass('isOpen');
      }
        
       let aboutDistributorBoxTop = $('.aboutDistributorBox').offset().top;
       $("html,body").animate({
            scrollTop:aboutDistributorBoxTop - 140
            }, 1200, 'swing');
            return false;
    });
 
    //地図サブナビをクリックした際の処理
      var thisArea, areaList,currentName;
      
      changeJs.on('click', function () {
        responsibleCheck = $('#responsibleCheck').width();
        thisArea = $(this).attr('class');
        areaList = $('section.' + thisArea);
        changeJs = $('#aboutDistributorSubNavMenu li');

        if ($(areaList).css('display') == 'none') {
          countryArea.not(areaList).css('display', 'none');
          areaList.css('display', 'block');
            
          $('g').removeClass('active');
          $('g#' + thisArea).addClass('active');
        }
          
          changeJs.removeClass('active');
          $(this).addClass('active');
          
          activeSp = $('.activeSp');
          if (responsibleCheck == '2') {
              $('#changeJs').slideUp(500);
              activeSp.removeClass('isOpen');
            }
          
          activeSp.removeClass('isOpen');
          
          currentName = $(this).html(); 
          $('.selectBtn').html(currentName);
          
          let aboutDistributorBoxTop = $('.aboutDistributorBox').offset().top;
            $("html,body").animate({
            scrollTop:aboutDistributorBoxTop - 140
            }, 1200, 'swing');
            return false;
      });
      
    //CEO interview
    let ceoInterviewNavLi = $('.ceoInterviewNavLi');
    let ceoInterviewPaging= $('.ceoInterviewPaging p a');
      
      ceoInterviewNavLi.on('click', function () {
          let article = $(this).index();
          
          $(".ceoInterviewArticleVol").removeClass("active");
          $(".ceoInterviewArticleVol").eq(article).addClass("active");

          ceoInterviewNavLi.removeClass('active');
          $(this).addClass('active');
          
          return false;
      });
      
      ceoInterviewPaging.on('click', function () {
          $(".ceoInterviewArticleVol").removeClass("active");
          $(".ceoInterviewArticleVol").filter(this.hash).addClass("active");

          ceoInterviewNavLi.removeClass('active');
          $('.'+$(this).attr('id')).addClass("active");
          
          $("html,body").animate({
            scrollTop:$(".ceoInterviewHeadTxt").offset().top
            }, 0, 'swing');
          
          return false;
      });
      
      //JOBS
      let aboutJobsListTit = $('.aboutJobsListTit');
      
      aboutJobsListTit.on('click', function () {
          $(this).next().stop().slideToggle(600);
          $(this).toggleClass('active');
      });
      
      /* ----------------------------------------------------------------------------------
	       自動ループスライダー
	  ---------------------------------------------------------------------------------- */
      let loopSliderFunc = function () {
          let speed;
          let loopsliderWidth;
          let loopsliderHeight;
          let loopHeight;
          let listMainElem;
          let listWidth;
          let listCount;
          let loopWidth;
          let intervalTimer;
          let responsibleCheck;
          let mainElem = '#loopSlider';
          let isSp = null; // 現在SP用表示かどうかを判断するフラグ
          let slideCount; 
          let slideCountSp; 

          $(mainElem).each(function () {
              loopHeight = $(this).height();
              listMainElem = '#loopSliderWrap';
              loopsliderWidth = $(this).width(); // 幅を取得
              loopsliderHeight = $(this).height(); // 高さを取得
              listWidth = $(listMainElem).find('ul li').width();
              listCount = $(listMainElem).find('ul li').length;
              loopWidth = listWidth * listCount;
              slideCount = listCount * 2;// 投稿スライド画像枚数に応じてサイズ調整
              slideCountSp = slideCount * 2;
              console.log("読み込み中");
              
              responsibleCheck = $('#responsibleCheck').width();
              if (responsibleCheck == '1') {
                  // PCの処理
                  speed = 100000;
              } else if (responsibleCheck == '2') {
                  // SPの処理
                  speed = 50000;
              }
              
              // ロード、リサイズで処理
              let resizeLoop = function (){
                  // ロード時に要素を表示させる
                  $(mainElem).css({
                      visibility: 'visible'
                  });
                  $(mainElem).stop().animate({
                      opacity: '1'
                  }, 900, 'swing');

                  // 4でSP以下を判断
                  responsibleCheck = $('#responsibleCheck').width();
                  if (responsibleCheck == '1') {
                      // PCの処理
                      // サイズ調整
                      $(listMainElem).css({
                          width: loopWidth * slideCount,
                          height: loopsliderHeight
                      });
                      $(mainElem).css({
                          height: loopHeight
                      });
                      $(mainElem).find('.loopImgItem').css({
                          width: listWidth,
                          height: loopHeight
                      });

                  } else if (responsibleCheck == '2') {
                      // SPの処理
                      // サイズ調整
                      $(listMainElem).css({
                          width: loopWidth * slideCount,
                          height: loopsliderHeight
                      });
                      $(mainElem).css({
                          height: loopHeight
                      });
                      $(mainElem).find('.loopImgItem').css({
                          width: listWidth * slideCount,
                          height: loopHeight
                      });
                      
                      console.log("sp");
                      
                  }
                  console.log("読み込み完了");
              }
              
              loopPosition(loopWidth);
              resizeLoop();
              $(window).resize(resizeLoop);
              $(listMainElem).find('ul').clone().appendTo(listMainElem).clone().appendTo(listMainElem);
          });

          // ポジション処理
          function loopPosition(loopWidth) {
              $(listMainElem).css({
                  left: '0'
              });
              $(listMainElem).stop().animate({
                  left: '-' + loopWidth + 'px'
              }, speed, 'swing');
              if (intervalTimer !== false) {
                  clearTimeout(intervalTimer);
              }
              intervalTimer = setTimeout(function () {
                  loopPosition(loopWidth);
              }, speed);
          }
      }
      loopSliderFunc();
  }
}